import {
  GET_BROADCAST,
  SET_BROADCAST,
  UPDATE_BROADCAST_SETTINGS
} from 'actions/Types';
import {
  BROADCAST_UPDATE_STREAM_REALTIME,
  BROADCAST_UPDATE_RECORDING_REALTIME
} from '@shoflo/studio-redux/actions/types';
const initialState = {
  settings: {
    muteMeetingAudio: false
  }
};

function broadcast(state = initialState, action) {
  switch (action.type) {
    case `${GET_BROADCAST}_SUCCESS`:
    case SET_BROADCAST:
      return {
        ...state,
        ...action.payload
      };

    case UPDATE_BROADCAST_SETTINGS: {
      return {
        ...state,
        settings: {
          ...(state.settings || {}),
          ...action.payload
        }
      };
    }

    case BROADCAST_UPDATE_STREAM_REALTIME: {
      const updatedEndpoints = upsertById(action.payload, state.endpoints);
      return {
        ...state,
        endpoints: updatedEndpoints
      };
    }

    case BROADCAST_UPDATE_RECORDING_REALTIME: {
      const updatedRecordings = upsertById(action.payload, state.recordings);
      return {
        ...state,
        recordings: updatedRecordings
      };
    }

    default:
      return state;
  }
}

// Keeps the recordings/endpoints in sync by inserting a new recording/endpoint
// Or merging updates for an existing _id.
const upsertById = (payload, broadcastOutput = []) => {
  const exists = broadcastOutput.some(item => item._id === payload._id);
  if (!exists) {
    return [...broadcastOutput, payload];
  }
  return broadcastOutput.map(item =>
    item._id === payload._id ? { ...item, ...payload } : item
  );
};

export default broadcast;
